// components/LightnerSection.jsx
import { Fragment } from "react";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import styles from "../Info.module.css";

const steps = [
  {
    icon: "fa-clapperboard",
    title: "دیدن لغت توی فیلم",
    desc: "عبارت کلیدی جلوی چشمته",
  },
  {
    icon: "fa-mouse-pointer",
    title: "کلیک و ذخیره",
    desc: "همین‌جا توی پلیر ذخیره کن",
  },
  {
    icon: "fa-layer-group",
    title: "انتقال به لایتنر",
    desc: "بسته‌بندی و آماده مرور",
  },
  {
    icon: "fa-calendar-check",
    title: "مرور فاصله‌دار",
    desc: "هر لغت توی زمان درستش",
  },
];

const LightnerSection = () => {
  return (
    <section className={styles.section}>
      <div className={styles.sectionInner}>
        <Reveal>
          <SectionHeading
            badge="ویژه ⭐"
            badgeColor="gold"
            title="ذخیره‌سازی و لایتنر هوشمند"
            subtitle="از لحظه دیدن تا ماندگاری بلندمدت — چرخه‌ای که هیچ لغتی رو جا نمی‌ذاره."
          />
        </Reveal>

        <Reveal delay={100}>
          <div className={styles.lightnerRow}>
            {steps.map((step, idx) => (
              <Fragment key={idx}>
                {idx > 0 && (
                  <span className={styles.lightnerArrow}>
                    <i className="fas fa-chevron-left"></i>
                  </span>
                )}
                <div className={styles.lightnerCard}>
                  <span className={styles.lightnerIcon}>
                    <i className={`fas ${step.icon}`}></i>
                  </span>
                  <span className={styles.lightnerTitle}>{step.title}</span>
                  <span className={styles.lightnerDesc}>{step.desc}</span>
                </div>
              </Fragment>
            ))}
          </div>
        </Reveal>

        <Reveal delay={150}>
          <p className={styles.demoCaption}>
            هیچ لغتی از دستت نمی‌ره. همه‌شون توی لایتنر منتظرت هستن.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default LightnerSection;